<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户维护</el-breadcrumb-item>
      <el-breadcrumb-item>客户回访</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="10">
          <el-input
            placeholder="请输入查询内容"
            v-model="queryInfo.query"
            class="input-with-select"
            clearable
            style="width:300px "
            @clear="getHuifangList"
            @change="getHuifangList"
          >
            <el-button slot="append" icon="el-icon-search" @click="getHuifangList"></el-button>
          </el-input>
        </el-col>
 
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="huifangList" style="width: 100%" border stripe>
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column prop="huifang_uid" label=" 序号" width="80"><template v-slot="scope">
               {{scope.row.uid}} </template></el-table-column>
            <el-table-column prop="guest_bianhao" label="客户编号" width="120"></el-table-column>
            <el-table-column prop="guest_name" label="客户名称"></el-table-column>
            <el-table-column prop="huifang_title" label="回访标题"></el-table-column>
            <el-table-column prop="huifang_memo" label="回访内容"></el-table-column>
            <el-table-column prop="add_time" label="加入时间"></el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
               
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                  :enterable="false"
                >
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="mini"
                    @click="deleteForm(scope.row.uid)"
                  ></el-button>
                </el-tooltip>
               
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum"
        :page-sizes="[10,50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>

      <!-- 修改客户信息 -->
      
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      guestLy_options: [
      {
          value: 1,
          label: '抖音'
        },
        {
          value: 2,
          label: '美团'
        },
        {
          value: 3,
          label: '自然到店'
        },
        {
          value: 4,
          label: '邀约'
        },
        {
          value: 5,
          label: '转介绍'
        },
        {
          value: 6,
          label: '领券'
        },
        {
          value: 7,
          label: '其他'
        }
      ],
      guest_options: [
        {
          value: 1,
          label: '初级客户'
        },
        {
          value: 2,
          label: '中级客户'
        },
        {
          value: 3,
          label: '高级客户'
        }
      ],
      // 获取用户列表参数
      queryInfo: {
        C_type: 'get_list',
        C_table_name: 'guest_huifang_list',
        query: '',
        pageNum: 1,
        pageSize: 10
      },
      huifangList: [],
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      huifangDialogVisible: false,

      // 用于设置回访页面滑块值
      //  添加表单数据项
      addForm: {
        C_type: 'huifang_add',
        huifang_uid: 0,
        guest_bianhao: '',
        huifang_title: '',
        hufiang_memo: '',
        add_time: '',
        huifang_date: '',
        guest_name: '',
        guest_mob: '',
        guest_addr: '',
        guest_laiyuan: 0
      },

      // 用于修改数据绑定
      editForm: {},
      // 表单规则项
      addFormRules: {
        guest_name: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
          { min: 3, max: 10, message: '必须3到10位字符 ', trigger: 'blur' }
        ],
        guest_admin: [
          { required: true, message: '请输入客户管理员', trigger: 'blur' },
          { min: 3, max: 10, message: '必须3到10位字符', trigger: 'blur' }
        ],
        guest_mob: [
          { required: true, message: '请输入管理员手机号码', trigger: 'blur' },
          { min: 11, max: 11, message: '必须是11位 ', trigger: 'blur' }
        ]
      },
      huifangFormRefRules: {
        huifang_title: [
          { required: true, message: '请输入回访标题', trigger: 'blur' },
          { min: 1, max: 1000, message: '必须1位字符 ', trigger: 'blur' }
        ]
      },

      editFormRules: {}
    };
  },
  created() {
    this.getHuifangList();
  },
  methods: {
    get_switch_value(switchValue) {
      this.huifangForm.huifang_genjin = switchValue ? 1 : 0;
      console.log(this.huifangForm.huifang_genjin);
    },
    async huiFangAdd() {
      const { data: res } = await this.$http.post('api', this.huifangForm);
      console.log(JSON.parse(res.data)[0].bianhao_s);
      this.huifangDialogVisible = true;
    },
    async get_guest_add() {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_type: 'get_bianhao', C_table_type: 3 }
      });
      console.log(JSON.parse(res.data)[0].bianhao_s);
      this.addForm.guest_bianhao = JSON.parse(res.data)[0].bianhao_s;
      // this.total = JSON.parse(res.data)[0].total
      this.addDialogVisible = true;
    },

    async getHuifangList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
       console.log(JSON.parse(res.data))
      this.huifangList = JSON.parse(res.data)[0].dataList;

      console.log(this.huifangList)
      if (!this.huifangList) return;
      this.huifangList.forEach(function(item) {
        item.yong_flag = item.yong_flag === 1;
      });

      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total)
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getHuifangList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getHuifangList();
    },
    // 删除一条记录
    async deleteForm(huifangUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确定删除该条记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'huifang_del',
        C_data1: huifangUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败');
        return;
      }
      this.$message.success('删除成功');
      this.getHuifangList();
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important ;
  background-color: #f2f6fc;
}
.el_row_two {
  margin-top: 30px;
}
</style>
